// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_ON,
} from 'components/header-layout/constants/header-layout.constants';
// Types
import { ErrorHandlersType } from './types/error.handlers.type';

const tryAgainOnboardingProcessButtonClickHandler = (): void => {
  localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
  window.location.reload();
};

const ErrorHandlers = (): ErrorHandlersType => ({
  handleTryAgainOnboardingProcessButtonClick: () => tryAgainOnboardingProcessButtonClickHandler(),
});

export { ErrorHandlers };
